<ng-container *transloco="let t;">
    <form [formGroup]="formGroup">
        @for(field of group.fields; track field; let idx = $index){
            @if(field.type === 'default' && field.field_name === 'document_type'){
                <div class="mb-50 top_section_field">
                    <label class="col-form-label p-0" for="name">{{ field.label }}</label>
                    <ng-select [items]="documentTypes$ | async"
                        formControlName="document_type" 
                        bindLabel="document_type" 
                        bindValue="id" 
                        (change)="updateDocumentType($event)" 
                        [clearable]="false"
                        [searchable]="true" 
                        [placeholder]="t('Select empty placeholder (drop down list) - Please select')"
                        [ngClass]="{ 'is-invalid error document_type_id': formGroup.get('document_type')?.errors }">
                    </ng-select>
                </div>
            }
            @if((field.type === 'document_category') && (!field?.category?.parent_id || field?.category?.parent_id == 0)){
                <div class="mb-50">
                     <app-cascader-select
                        [categories]="[field.category]"
                        [selectedIds]="formGroup.get(field.field_name)?.value ?? []"
                        [label]="field.category.category_name"
                        [disabled]="!(hasFullAccessToDocument || canEditDocument)"
                        (save)="selectedCategoriesChange($event, idx)"
                    ></app-cascader-select>
                </div>
            }

            @if(field.type === 'index_field' || field.type === 'document_field') {
                <div class="mb-50">
                    <label class="col-form-label p-0" for="name">{{ field.meta_data?.meta_data_name }}</label>
                    @if(field?.meta_data?.meta_data_type === 'text'){
                        <app-text-field [field]="field" (valueChange)="valueChange($event, field)" [value]="field.value ?? ''" [readOnly]="!(hasFullAccessToDocument || canEditDocument)"></app-text-field>
                    }
                    @if(field?.meta_data?.meta_data_type === 'droplist'){
                        <app-select-field [field]="field" (valueChange)="valueChange($event, field)" [value]="field.value ?? ''" [readOnly]="!(hasFullAccessToDocument || canEditDocument)"></app-select-field>
                    }
                    @if(field?.meta_data?.meta_data_type === 'checkbox'){
                        <app-checkbox-field [field]="field" (valueChange)="valueChange($event, field)" [value]="field.value ?? ''" [index]="idx" [readOnly]="!(hasFullAccessToDocument || canEditDocument)"></app-checkbox-field>
                    }
                    @if(field?.meta_data.meta_data_type === 'datepicker'){
                        <app-datepicker-field [field]="field" (valueChange)="valueChange($event, field)" [value]="field.value ?? ''" [readOnly]="!(hasFullAccessToDocument || canEditDocument)"></app-datepicker-field>
                    }
                </div>
            }
        }
    </form>
</ng-container>